import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneStaff from "./OneStaff";

export default function StaffBanner() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllStaff()]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container py-5 d-flex justify-content-center">
        {getInlineLoader()}
      </div>
    );
  }

  const staff = Array.isArray(appContext.allStaff) ? appContext.allStaff : [];

  return (
    <section
      className="py-5"
      style={{
        backgroundColor: "#f8fafc",
        backgroundImage: "radial-gradient(#e2e8f0 1px, transparent 1px)",
        backgroundSize: "24px 24px",
      }}
    >
      <div className="container py-4">
        {/* Clean Header Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-7 text-center">
            <span
              className="text-uppercase fw-bold text-primary mb-2 d-block"
              style={{ fontSize: "0.75rem", letterSpacing: "0.15em" }}
            >
              Our Team
            </span>
            <h2
              className="fw-bold mb-3"
              style={{
                fontSize: "2.25rem",
                color: "#0f172a",
                letterSpacing: "-0.02em",
              }}
            >
              Meet the Experts
            </h2>
            <p
              className="text-muted mb-0"
              style={{ fontSize: "1.05rem", lineHeight: "1.6", maxWidth: "600px", margin: "0 auto" }}
            >
              Dedicated professionals committed to delivering quality, integrity, and strategic excellence across Tanzania.
            </p>
          </div>
        </div>

        {/* Staff Grid */}
        <div className="row g-4 justify-content-center">
          {staff.length > 0 ? (
            staff.map((item, i) => (
              <div key={i} className="col-12 col-md-6 col-lg-4">
                <OneStaff data={item} />
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="text-center py-5 bg-white rounded-3 border shadow-sm">
                <p className="text-muted mb-0">No staff records found.</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}